// extracted by mini-css-extract-plugin
export default {"container":"ChatMessages_container__BCGV7","chatTextBox":"ChatMessages_chatTextBox__9DkPm","chatInput":"ChatMessages_chatInput__NEl2Y"};